import React from 'react';

interface Props {
    label?: string;
    placeholder?: string;
    type?: string;
    value: any;
    setValue: (value: any) => void;
}

function TextField(props: Props) {
    return (
        <div className="text-field">
            {props.label ? <div className="label">{props.label}</div> : null}
            <input
                type={props.type}
                value={props.value}
                placeholder={props.placeholder || 'Enter value'}
                onChange={(e) => props.setValue(e.target.value)}
            />
        </div>
    );
}

export default TextField;
